import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Api from '../../Config/Api';
import MasterApi from '../../Config/MasterApi';


export const getSpajs = createAsyncThunk('SPAJ/getSPAJ', async (data) => {
    return Api.post(Api.routeHelper+MasterApi.getSPAJHeader, data)
        .then(response => {
            return response;
        })
        .catch(err => {
            return err
        })
})

export const getDetail = createAsyncThunk('SPAJ/detailSPAJ', async (data) => {
    return Api.post(Api.routeEapp+MasterApi.getDetailSPAJ, data)
        .then(response => {
            return response;
        })
        .catch(err => {
            return err
        })
})

export const updateStatusSpaj = createAsyncThunk('SPAJ/updateStatus', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.updateStatusSPAJ, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const rejectPendingDoc = createAsyncThunk('SPAJ/rejectPendingDoc', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.rejectPendingDoc, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const finalPaymentUL = createAsyncThunk('SPAJ/finalPaymentUL', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.finalPaymentUL, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getPendingDocument = createAsyncThunk('SPAJ/getPendingList', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.getPendingDocument, data)
    .then(response => {
        return response;
    })
    .catch(err=>{
        return err;
    });
});

export const SPAJSlice = createSlice(({
    name: "SPAJs",
    initialState: {
        SPAJs: [],
        loading: false
    },
    reducers: {
        updateStatusCustomer: (state, action) =>{
            state.SPAJs.spajHeader.statusCustomer = action.payload
        }
    },
    extraReducers: {
        [getSpajs.pending]: (state, action) => {
            state.loading = true
        },
        [getSpajs.fulfilled]: (state, action) => {
            state.loading = false
            state.SPAJs = action.payload.data
        },
        [getSpajs.rejected]: (state, action) => {
            state.loading = false
        }
    }
}))

export const { updateStatusCustomer } = SPAJSlice.actions

export const SPAJDetailSlice = createSlice(({
    name: "SPAJDetail",
    initialState: {
        SPAJDetail: [],
        loading: false
    },
    extraReducers: {
        [getDetail.pending]: (state, action) => {
            state.loading = true
        },
        [getDetail.fulfilled]: (state, action) => {
            state.loading = false
            state.SPAJDetail = action.payload.data
        },
        [getDetail.rejected]: (state, action) => {
            state.loading = false
        },
    }
}))

export default SPAJSlice.reducer
